import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { actions as authActions } from '../../../reducers/auth'

import FacebookLoginButton from '@fe/ui/FacebookLoginButton'

import Button from './Button'

import apolloClient from '../../../apollo'
import { useMutation } from 'react-apollo'
import { loader } from 'graphql.macro'
const continueWithAuthMutation = loader('../continueWithAuth.gql')

const FacebookLoginBase = props => {
  const [authenticate] = useMutation(continueWithAuthMutation, { client: apolloClient })
  const handleLogin = async resp => {
    if (!_.get('accessToken', resp)) {
      console.warn('Unable to use Facebook sign in:', resp)
      return
    }
    const token = _.get('accessToken', resp)
    const { data: { continueWithAuth } } = await authenticate({ variables: { provider: 'FACEBOOK', token } })
    if (continueWithAuth.isNewUser) {
      const { name, email, clubId, clubName } = continueWithAuth
      props.history.replace('/signup', {
        userProfile: _.omitBy(_.isNil, { // Drop nulls and undefineds as validator.js can't handle NULL
          name,
          email,
          clubId,
          clubName
        }),
        cameFromSocialSignup: true,
        socialSignupOutput: continueWithAuth
      })
    } else {
      const {
        id: email,
        otp: password,
        provider
      } = continueWithAuth
      props.doLogin({ email, password, provider })
    }
  }

  return (
    <FacebookLoginButton
      appId='1020695051398914'
      scope='public_profile,email'
      callback={handleLogin}
      render={({ onClick }) => (
        <Button
          icon={<span style={{ width: 24, margin: '-2px 0', textAlign: 'center', fontSize: 16 }}>f</span>}
          buttonColor='#4c69ba'
          onClick={onClick}
        >
          Continue with Facebook
        </Button>
      )}
    />
  )
}

export default _.compose(
  connect(() => ({}), ({
    doLogin: authActions.loginRequest
  })),
  withRouter
)(FacebookLoginBase)
